import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import RAGIndicator from "components/visuals/RAGIndicator";

import { selectors } from "modules/customer/insights/portfolio/profit/netProfit";

const ProfitabilityEvaluation = () => {
    const profitabilityEvaluation = useSelector(state => selectors.profitabilityEvaluation(state));
    const { loading, error, id, label, status, value } = profitabilityEvaluation;

    return (
        <Box data-cy={id}>
            <RAGIndicator loading={loading} error={error} label={label} status={status} value={value} />
        </Box>
    );
};

export default ProfitabilityEvaluation;
